import {
	Configuration,
	AnnouncementsApi,
	StatesApi,
	VehiclesApi,
	VehicleTypesApi,
	TagsApi,
	UserNotificationSettingsApi,
	OrganizationBlockedOfficersApi,
	OrganizationFavoriteGroupsApi,
	OrganizationOfficerConstraintsApi,
	PayCodesApi,
	ApiErrorFromJSON,
	TimecardsApi,
	TimecardAttachmentsApi,
	ProjectsApi,
	OfficerRanksApi,
	ClientJobRequestsApi,
	OfficerCertificationTypesApi,
	JurisdictionFeesApi,
	OfficerCallOffsApi,
	OfficerCallOffPenaltyRulesApi,
	AutoAssignmentsApi,
	ExternalOfficersApi,
	LocationGroupsApi,
	NotesApi,
	ZonesApi,
	LocationsApi,
	JobEventTypesApi,
	DressTypesApi,
	JobEventDraftsApi,
	ClientInvitationsApi,
	ChatsApi,
	JobEventChatParticipantsApi,
	HubSpotApi,
	ClientDocumentsApi,
	DashboardsApi,
	NonRKPayInvoiceEstimatesApi,
	TimeZonesApi,
	JurisdictionLocationApprovalsApi,
	JurisdictionsApi,
	InstantPayApi,
	ContactsApi,
	ClientsApi,
	JurisdictionShiftsApi,
	DisputesApi,
	NonRKPayInvoiceApi,
} from "@rollkall/nexus-client";
import { API_CORE_URL } from "@constants";
import MicrosoftAuthenticationService from "./MicrosoftAuthenticationService";
import { throwIfNetworkError } from "../utils/network";

const { getToken } = MicrosoftAuthenticationService;

const adb2cMiddleware = {
	pre: async ctx => {
		const headers = {};

		try {
			const token = await getToken();

			headers.Authorization = `Bearer ${token}`;
		} catch (error) {
			// no-op
		}

		if (ctx.init.headers === undefined) ctx.init.headers = headers;
		else ctx.init.headers = { ...ctx.init.headers, ...headers };

		return {
			url: ctx.url,
			init: ctx.init,
		};
	},
};

const errorMiddleware = {
	// eslint-disable-next-line consistent-return
	post: async ctx => {
		if (ctx.response.status >= 400 && ctx.response.status < 600) {
			const json = await ctx.response.json();
			return {
				data: ApiErrorFromJSON(json),
			};
		}
	},
	onError: async (ctx) => {
		throwIfNetworkError(ctx.error);

		return undefined;
	},
};

const config = new Configuration({
	basePath: API_CORE_URL,
	middleware: [adb2cMiddleware, errorMiddleware],
});

/*
	As more apis are added, they can be incorporated into the NexusService object.
*/
export default {
	statesApi: new StatesApi(config),
	announcementsApi: new AnnouncementsApi(config),
	vehiclesApi: new VehiclesApi(config),
	vehicleTypesApi: new VehicleTypesApi(config),
	tagsApi: new TagsApi(config),
	userNotificationSettingsApi: new UserNotificationSettingsApi(config),
	organizationBlockedOfficersApi: new OrganizationBlockedOfficersApi(config),
	organizationFavoriteGroupsApi: new OrganizationFavoriteGroupsApi(config),
	organizationOfficerConstraintsApi: new OrganizationOfficerConstraintsApi(config),
	payCodesApi: new PayCodesApi(config),
	timecardsApi: new TimecardsApi(config),
	timecardAttachmentsApi: new TimecardAttachmentsApi(config),
	projectsApi: new ProjectsApi(config),
	officerRanksApi: new OfficerRanksApi(config),
	clientJobRequestsApi: new ClientJobRequestsApi(config),
	OfficerCertificationTypesApi: new OfficerCertificationTypesApi(config),
	jurisdictionFeesApi: new JurisdictionFeesApi(config),
	officerCallOffsApi: new OfficerCallOffsApi(config),
	officerCallOffPenaltyRulesApi: new OfficerCallOffPenaltyRulesApi(config),
	autoAssignmentsApi: new AutoAssignmentsApi(config),
	externalOfficersApi: new ExternalOfficersApi(config),
	locationGroupsApi: new LocationGroupsApi(config),
	notesApi: new NotesApi(config),
	zonesApi: new ZonesApi(config),
	locationsApi: new LocationsApi(config),
	jobEventTypesApi: new JobEventTypesApi(config),
	dressTypesApi: new DressTypesApi(config),
	jobEventDraftsApi: new JobEventDraftsApi(config),
	clientInvitationsApi: new ClientInvitationsApi(config),
	chatsApi: new ChatsApi(config),
	jobEventChatParticipantsApi: new JobEventChatParticipantsApi(config),
	clientDocumentsApi: new ClientDocumentsApi(config),
	hubSpotApi: new HubSpotApi(config),
	dashboardsApi: new DashboardsApi(config),
	nonRKPayInvoiceEstimatesApi: new NonRKPayInvoiceEstimatesApi(config),
	timeZonesApi: new TimeZonesApi(config),
	jurisdictionLocationApprovalsApi: new JurisdictionLocationApprovalsApi(config),
	jurisdictionsApi: new JurisdictionsApi(config),
	instantPayApi: new InstantPayApi(config),
	contactsApi: new ContactsApi(config),
	clientsApi: new ClientsApi(config),
	jurisdictionShiftsApi: new JurisdictionShiftsApi(config),
	disputesApi: new DisputesApi(config),
	nonRKPayInvoiceApi: new NonRKPayInvoiceApi(config),
};
